import React, { useState } from 'react'
import moment from 'moment'
import classNames from 'classnames'
import NumberFormat from 'react-number-format'
import {
  Button,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner
} from 'reactstrap'
import FieldError from '../provider/FieldError'

const DESCRIPTION_MAX = 2000

const QuoteModal = ({ isOpen, toggle, onSubmit }) => {
  const today = moment().format('YYYY-MM-DD')
  const [form, setForm] = useState({ amount: '', description: '', valid_until: '' })
  const [errors, setErrors] = useState({})
  const [sending, setSending] = useState(false)

  const change = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }))
    setErrors((prev) => ({ ...prev, [field]: null }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    const formErrors = {}
    if (!(Number(form.amount) > 0)) formErrors.amount = 'Indica el monto de la cotización.'
    if (form.description.trim().length < 10) formErrors.description = 'Detalla qué incluye: al menos 10 caracteres.'
    if (form.valid_until && form.valid_until < today) formErrors.valid_until = 'La fecha de validez no puede ser anterior a hoy.'
    if (Object.keys(formErrors).length) {
      setErrors(formErrors)
      return
    }

    setSending(true)
    try {
      await onSubmit(
        { amount: form.amount, description: form.description.trim(), valid_until: form.valid_until || null },
        setErrors
      )
    } finally {
      setSending(false)
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={sending ? undefined : toggle} centered>
      <Form onSubmit={handleSubmit} noValidate>
        <ModalHeader toggle={sending ? undefined : toggle}>Enviar cotización</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Monto total</Label>
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>$</InputGroupText>
              </InputGroupAddon>
              <NumberFormat
                className={classNames('form-control', { 'is-invalid': errors.amount })}
                value={form.amount}
                placeholder="0,00"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                allowNegative={false}
                isNumericString
                inputMode="decimal"
                onValueChange={({ value }) => change('amount', value)}
              />
            </InputGroup>
            <FieldError error={errors.amount} />
          </FormGroup>
          <FormGroup>
            <Label for="quote-description">Qué incluye</Label>
            <Input
              id="quote-description"
              type="textarea"
              rows={4}
              maxLength={DESCRIPTION_MAX}
              value={form.description}
              invalid={Boolean(errors.description)}
              onChange={({ target }) => change('description', target.value)}
              placeholder="Ej.: Cambio del sifón y de la llave de paso, materiales incluidos. Garantía de 30 días."
            />
            <FieldError error={errors.description} />
          </FormGroup>
          <FormGroup className="mb-0">
            <Label for="quote-valid-until">Válida hasta (opcional)</Label>
            <Input
              id="quote-valid-until"
              type="date"
              min={today}
              value={form.valid_until}
              invalid={Boolean(errors.valid_until)}
              onChange={({ target }) => change('valid_until', target.value)}
            />
            <small className="text-600 d-block mt-1">Si envías otra cotización, esta queda reemplazada.</small>
            <FieldError error={errors.valid_until} />
          </FormGroup>
          <FieldError error={errors.status} />
        </ModalBody>
        <ModalFooter>
          <Button color="falcon-default" onClick={toggle} disabled={sending}>
            Cancelar
          </Button>
          <Button type="submit" color="primary" disabled={sending}>
            {sending && <Spinner size="sm" className="mr-2" />}
            Enviar cotización
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  )
}

export default QuoteModal
